import ClearIcon from '@mui/icons-material/Clear';
import {IconButton} from '@mui/material';
import React, {FC, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import { clearSnackbar } from 'shared/state/ducks/snackbar/snackbar-slice';
import { localized } from 'shared/state/i18n/i18n';


export const SnackbarCloseButton: FC<{snackKey: number}> = React.memo(({snackKey}) => {
  const dispatch = useDispatch();

  const onClickDismiss = useCallback(() => {
    dispatch(clearSnackbar(snackKey));
  }, [dispatch, snackKey]);

  return (
    <IconButton aria-label={localized('Close')} onClick={onClickDismiss} size="large">
      <ClearIcon />
    </IconButton>
  );
});
